var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextgre2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.5 167.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.37,2.3l27.3,133.02c-1.09,3.67-6.58,3.78-8.57,1.1-3.81-5.15-6.88-39.31-9.67-41.27l-35.36-.55c-1.95.53-9.29,33.74-11.5,38.83-3.51,8.09-11.39,4.22-10.51-1.73L55.82,2.57c3.12-4.33,5.61-2.31,9.55-.26ZM72.18,84.86l-12.53-59.95-16.89,59.95h29.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.06,149.16h234.32c-3.07-7.78,7.64-12.37,9.59-5.77.9,3.04.78,21.65-1.31,23.31-1.89,1.42-4.92,1.56-6.77,0l-2.04-5.58-3.24-1.12H13.82c-4.85-.63-2.92,4.72-5.28,6.7-2.09,1.57-5.66,1.54-7.31-.55-1.38-1.75-1.56-20.05-.76-22.77,1.94-6.6,12.66-2,9.59,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,107.89l-25.9-.03c-2.31,5.85-5.19,27.13-10.98,28.88-3.88,1.17-6.08-.96-6.3-4.74l29.1-97.87c3.68-3.45,8.31-2.69,9.85,2.25l19.65,98.06c-1.44,4.35-6.17,5.07-8.77,1.12s-5.17-26.72-6.65-27.68ZM133.76,97.94h17.44l1.43-2.47-7.98-36.77-12.09,36.99,1.2,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.4,61.06c2.7-.51,4.5.2,5.45,2.84,3.81,20.55,10.11,40.75,13.91,61.28.66,3.56,2.96,10.29-2.41,11.86-9.54,2.8-6.26-17.36-11.75-18.4-1.88-.36-12.51-.27-13.68.51l-6.48,16.41-4.69.34c-5.13-2.47-2.45-7.89-1.55-12.03,4.44-20.49,12.81-41.14,18.22-61.33.86-.67,1.9-1.28,2.98-1.48ZM216.04,107.74c-1.27-5.1-1.97-10.46-3.59-15.48-.37-1.14-.28-3.29-1.84-3.03l-4.37,18.51h9.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextgre2);
export default __webpack_public_path__ + "static/media/Textgröße 2.28eda48706d7a83cbf4b447b068ae0d0.svg";
export { ForwardRef as ReactComponent };